/* import __COLOCATED_TEMPLATE__ from './conversation-insights.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const ConversationInsights = templateOnlyComponent<Signature>();
export default ConversationInsights;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::ConversationInsights': typeof ConversationInsights;
    'inbox2/conversation-details-sidebar/sidebar-sections/conversation-insights': typeof ConversationInsights;
  }
}
